var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('IMTable',{attrs:{"is-loading":_vm.isLoading,"is-page":true,"is-search":true,"table-head":_vm.tableHead,"table-data":_vm.tableData,"pagination":{
      currentPage: _vm.meta.current_page,
      pageSize: _vm.meta.per_page,
      total: _vm.meta.total
    },"filterOptions":_vm.newFilterFields},on:{"update:tableHead":function($event){_vm.tableHead=$event},"update:tableData":function($event){_vm.tableData=$event},"onTdBox":_vm.onTdBox,"onFilterComp":_vm.onFilterComp,"currentChange":_vm.currentChange,"onSearch":_vm.onSearch}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0ea0021f","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Courseware/manage/index.vue
// module id = null
// module chunks = 